import {useState} from 'react';
import {useHistory} from 'react-router-dom';
import serialize from 'form-serialize';

import {alertBase, alertByError} from 'utils/alerts';
import {sendEnquiry} from 'api/enquiries';
import {useAuth} from 'contexts/AuthContext';
import {isEmpty} from 'lodash';

function usePublicContact(companyType, companyId, validation, callback) {
  const {isAuth} = useAuth();
  const history = useHistory();
  const [isSubmittingContact, setSubmittingContact] = useState(false);

  async function handleSubmitContact(e) {
    e.preventDefault();

    if (isSubmittingContact) return false;

    const form = e.target;

    const selects = form.getElementsByClassName('react-select--invalid');
    if (form.checkValidity() === false || !isEmpty(selects)) {
      form.classList.add('was-validated');
      return false;
    }

    if (!isAuth) {
      await alertBase({
        type: 'info',
        title: 'Log in required',
        text: 'You must be logged in to send enquiry.',
        cancelButtonText: 'Log in',
        onClose: () => {
          history.push('/login');
        },
      });

      return false;
    }

    try {
      const data = serialize(form, {hash: true, empty: true});

      // external validation
      if (validation) {
        const result = validation(data);
        if (!result) return false;
      }

      await setSubmittingContact(true);

      await sendEnquiry(companyId, companyType, data);

      await alertBase({
        text: `We will get back to you once we have reviewed your enquiry `,
      });

      // Reset form, reset validation status
      form.reset();
      form.classList.remove('was-validated');
      if (callback) callback(); // resets the select since there is no programatic way to reset select

      setSubmittingContact(false);
    } catch (error) {
      await alertByError(error);
      setSubmittingContact(false);
    }
  }

  return {
    isSubmittingContact,
    submitContact: handleSubmitContact,
  };
}

export default usePublicContact;
